//@flow
import Papa from 'papaparse';
import StringUtils from 'common/utils/StringUtils';

type ParseCSVArgTypes = {
    file: File,
    config?: Object
};

type ParserResponseType = {
    fileRows: Array<Object>,
    fileHeaders: Array<string>
};

type ParseCSVReturnType = Promise<{
    file: File,
    parsedFile: ParserResponseType
}>;

const parseCSV = ({
    file,
    config = {}
}: ParseCSVArgTypes): ParseCSVReturnType => {
    return new Promise((resolve, reject) => {
        Papa.parse(file, {
            header: true,
            escapeChar: '"',
            skipEmptyLines: true,
            worker: false,
            ...config,

            complete: results => {
                const { data, errors, meta } = results;
                if (errors.length === 0) {
                    const newData = data.filter(
                        row => !Object.values(row).every(StringUtils.isEmpty)
                    );
                    resolve({
                        file,
                        parsedFile: {
                            fileRows: newData,
                            fileHeaders: meta.fields
                        }
                    });
                } else {
                    reject({
                        file,
                        uploadErrors: errors.map(
                            error => `${error.code}: ${error.message}`
                        )
                    });
                }
            },
            error: error => {
                reject({
                    file,
                    uploadErrors: [`${error.code}: ${error.message}`]
                });
            }
        });
    });
};

export default parseCSV;
